/**
 * The "Project" choice at the top of a page that shows one project at a time: Deliverables (decisions 839, 843) and
 * Reports (R198, MB 4 Nov 2026: "a project selector like the Deliverables so reports are listed by project").
 */
import type { ReactElement } from 'react';
import type { PortalProject } from './api.ts';

export interface ProjectPickerProps {
  readonly projects: readonly PortalProject[];
  readonly value: string;
  readonly onChange: (projectId: string) => void;
}

export function ProjectPicker({ projects, value, onChange }: ProjectPickerProps): ReactElement {
  return (
    <label className="field">
      <span className="label">Project</span>
      <select className="input" value={value} onChange={(e) => onChange(e.target.value)}>
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.number} {p.title}
          </option>
        ))}
      </select>
    </label>
  );
}
